"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformBackendSystemApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Operations for ShapeDiver Geometry Backend Systems known by the Platform Backend.
 */
class SdPlatformBackendSystemApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "backendsystems";
    }
    /**
     * Query the backend systems.
     * @param query - {@link SdPlatformBackendSystemQueryParameters} query parameters.
     * @returns - {@link SdPlatformQueryResponse} response with {@link SdPlatformResponseBackendSystem} or {@link SdPlatformResponseBackendSystemAdmin} as result.
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.BackendSystemQuery, query);
    }
    /**
     * Create the backend system.
     * @param body - {@link SdPlatformRequestBackendSystemCreate} body parameters.
     * @returns - {@link SdPlatformPostResponse} with {@link SdPlatformResponseBackendSystemAdmin} as result.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.BackendSystemCreate, body);
    }
    /**
     * Updates the backend system.
     * @param id - the backend system id.
     * @param body - {@link SdPlatformRequestBackendSystemPatch} update parameters.
     * @returns - {@link SdPlatformPatchResponse} with {@link SdPlatformResponseBackendSystem} or {@link SdPlatformResponseBackendSystemAdmin} as result.
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.BackendSystemPatch, id, body);
    }
    /**
     * Get a token for interacting with a geometry backend system.
     * @param body - {@link SdPlatformRequestBackendSystemToken} body
     * @returns - {@link SdPlatformPostResponse} with {@link SdPlatformResponseBackendSystemToken} as result.
     */
    token(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.BackendSystemToken, ResourcesApi_1.Action.Post, "token", body);
    }
    /**
     * Delete a backend system.
     * @param id - the id of a backend system
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.BackendSystemDelete, id);
    }
}
exports.SdPlatformBackendSystemApi = SdPlatformBackendSystemApi;
//# sourceMappingURL=SdPlatformBackendSystemApi.js.map